import React from 'react';

const ExternalLink = () => (
    <svg width="14" height="14" viewBox="0 0 24 18" xmlns="http://www.w3.org/2000/svg">
        <path
            d="M18 12c-0.6 0-1 0.4-1 1v6c0 0.6-0.4 1-1 1h-11c-0.6 0-1-0.4-1-1v-11c0-0.6 0.4-1 1-1h6c0.6 0 1-0.4 1-1s-0.4-1-1-1h-6c-1.7 0-3 1.3-3 3v11c0 1.7 1.3 3 3 3h11c1.7 0 3-1.3 3-3v-6c0-0.6-0.4-1-1-1z"
            fillRule="nonzero"
            fill="#FFF"
        />
        <path
            d="M21.9 2.6c-0.1-0.2-0.3-0.4-0.5-0.5-0.1-0.1-0.3-0.1-0.4-0.1h-6c-0.6 0-1 0.4-1 1s0.4 1 1 1h3.6l-9.3 9.3c-0.4 0.4-0.4 1 0 1.4 0.2 0.2 0.4 0.3 0.7 0.3s0.5-0.1 0.7-0.3l9.3-9.3v3.6c0 0.6 0.4 1 1 1s1-0.4 1-1v-6c0-0.1 0-0.3-0.1-0.4z"
            fillRule="nonzero"
            fill="#FFF"
        />
    </svg>
);

export default ExternalLink;



// WEBPACK FOOTER //
// ./src/components/Svg/ExternalLinkIcon.jsx